// const accountStoreName = 'accounts';
// const settingStoreName = 'settings';
// const pinStoreName = 'pins';
/**
 * vwIdb
 * accounts->import済みのアカウント情報を収納
 *
 * settings->optKeyによって収納する情報を分けている
 * ┗currentAccount=>loginId: string(現在選択中のアカウント)
 */

const state = {
    pinSaved: '',
    pin1: '',
    pin2: '',
    viewForward: false // 前に進んでいる最中か否か
}

const getters = {
    // countWithSuffix(state: any) {
    //     return `${state.counter} 回`
    // },
    getPin1(state: any) {
        return state.pin1;
    },
    getPin2(state: any) {
        return state.pin2;
    },

    getSavedPin(state: any) {
        return state.pinSaved;
    },

    getViewForward(state: any) {
        return state.viewForward;
    }
}

const actions = {
    // incActionCounter(store: any, payload: any){
    //     // Mutationsへ
    //     store.commit('incrementMutateCounter', payload)
    // },

    setPin1(store: any, payload: string) {
        store.commit('setPin1', payload);
        return new Promise(resolve => {
            resolve(true);
        });
    },
    setPin2(store: any, payload: string) {
        store.commit('setPin2', payload);
        return new Promise(resolve => {
            resolve(true);
        });
    },

    savePin(store: any, pin: string) {
        return new Promise((resolve) => {
            store.commit('savePin', pin);
            resolve(true);
        });
    },

    async setViewForward(store: any, viewForward: boolean) {
        store.commit('setViewForward', viewForward);
        return;
    },
}

const mutations = {
    setPin1(state: any, code: string) {
        state.pin1 = code;
    },
    setPin2(state: any, code: string) {
        state.pin2 = code;
    },

    savePin(state: any, code: string) {
        state.pinSaved = code;
    },

    setViewForward(state: any, viewForward: boolean) {
        state.viewForward = viewForward;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
